import gpio from "gpio";

const TCS34725_ADDRESS = 0x29;

const TCS34725_COMMAND_BIT = 0x80;

const TCS34725_ENABLE =		0x00;
const TCS34725_ENABLE_AIEN = 	0x10;    /* RGBC Interrupt Enable */
const TCS34725_ENABLE_WEN = 	0x08;    /* Wait enable - Writing 1 activates the wait timer */
const TCS34725_ENABLE_AEN = 	0x02;    /* RGBC Enable - Writing 1 actives the ADC, 0 disables it */
const TCS34725_ENABLE_PON = 	0x01;    /* Power on - Writing 1 activates the internal oscillator, 0 disables it */
const TCS34725_ATIME = 		0x01;	/* Integration time */
/* .. */
const TCS34725_CONTROL =	0x0F;    /* Set the gain level for the sensor */
const TCS34725_ID = 		0x12;    /* 0x44 = TCS34721/TCS34725, 0x4D = TCS34723/TCS34727 */

const TCS34725_CDATAL =         0x14;    /* Clear channel data */
const TCS34725_CDATAH =         0x15;
const TCS34725_RDATAL =         0x16;    /* Red channel data */
const TCS34725_RDATAH =         0x17;
const TCS34725_GDATAL =         0x18;   /* Green channel data */
const TCS34725_GDATAH =         0x19;
const TCS34725_BDATAL =         0x1A;    /* Blue channel data */
const TCS34725_BDATAH =         0x1B;

const TCS34725_INTEGRATIONTIME_2_4MS  = 0xFF;   /**<  2.4ms - 1 cycle    - Max Count: 1024  */
const TCS34725_INTEGRATIONTIME_24MS   = 0xF6;   /**<  24ms  - 10 cycles  - Max Count: 10240 */
const TCS34725_INTEGRATIONTIME_50MS   = 0xEB;   /**<  50ms  - 20 cycles  - Max Count: 20480 */
const TCS34725_INTEGRATIONTIME_101MS  = 0xD5;   /**<  101ms - 42 cycles  - Max Count: 43008 */
const TCS34725_INTEGRATIONTIME_154MS  = 0xC0;   /**<  154ms - 64 cycles  - Max Count: 65535 */
const TCS34725_INTEGRATIONTIME_700MS  = 0x00;   /**<  700ms - 256 cycles - Max Count: 65535 */

const TCS34725_GAIN_1X                = 0x00;   /**<  No gain  */
const TCS34725_GAIN_4X                = 0x01;   /**<  4x gain  */
const TCS34725_GAIN_16X               = 0x02;   /**<  16x gain */
const TCS34725_GAIN_60X               = 0x03;   /**<  60x gain */

class TCS34725 {
	constructor() {
		this.id = "TCS34725";
		this.status = "uninitialzed";
		this.__tcs34725Initialised = false;
		this.__tcs34725IntegrationTime = TCS34725_INTEGRATIONTIME_700MS;
		this.__tcs34725Gain = TCS34725_GAIN_1X;
	}
	initialize() {
		return( new Promise(function(resolve, reject) {
			this.status = "Failed";
			this.begin();
			this.status = "Ok";
		}.bind(this)) );
	}
	__write8(reg, value) {
		gpio.i2c[1].writeByte(TCS34725_ADDRESS, TCS34725_COMMAND_BIT | reg);
		gpio.i2c[1].writeByte(TCS34725_ADDRESS, value & 0xFF);
	}
	__read8(reg) {
		gpio.i2c[1].writeByte(TCS34725_ADDRESS, TCS34725_COMMAND_BIT | reg);
		return(gpio.i2c[1].readByte(TCS34725_ADDRESS));
	}
	__read16(reg) {
		gpio.i2c[1].writeByte(TCS34725_ADDRESS, TCS34725_COMMAND_BIT | reg);
		var t = gpio.i2c[1].readByte(TCS34725_ADDRESS);
		console.log("t:"+t);
		var x = gpio.i2c[1].readByte(TCS34725_ADDRESS);
		console.log("x:"+x);

		x = x << 8;
		x |= t;
		console.log("x->"+x);
		return(x);
	}
	__enable() {
		this.__write8(TCS34725_ENABLE, TCS34725_ENABLE_PON);

		this.__write8(TCS34725_ENABLE, TCS34725_ENABLE_PON | TCS34725_ENABLE_AEN);
/*
		this.__timer = setInterval(function() {
			clearInterval(this.__timer);
			this.__write8(TCS34725_ENABLE, TCS34725_ENABLE_PON | TCS34725_ENABLE_AEN);
			console.log("enable callback");
		}.bind(this), 5);
*/
	}
	__disable() {
		var reg = this.__read8(TCS34725_ENABLE);
		this.__write8(TCS34725_ENABLE, reg & ~(TCS34725_ENABLE_PON | TCS34725_ENABLE_AEN));
	}
	begin() {
		var x = this.__read8(TCS34725_ID);
		if ((x != 0x44) && (x != 0x10)) {
			throw new TypeError("Invalid device");
		}

		this.__tcs34725Initialised = true;

		/* Set default integration time and gain */
		this.setIntegrationTime(this.__tcs34725IntegrationTime);
		this.setGain(this.__tcs34725Gain);

		/* Note: by default, the device is in power down mode on bootup */
		this.__enable();

	}
	setIntegrationTime(it) {
		if (!this.__tcs34725Initialised) this.begin();

		/* Update the timing register */
		this.__write8(TCS34725_ATIME, it);

		/* Update value placeholders */
		this.__tcs34725IntegrationTime = it;
	}
	setGain(gain) {
		if (!this.__tcs34725Initialised) this.begin();

		/* Update the timing register */
		this.__write8(TCS34725_CONTROL, gain);

		/* Update value placeholders */
		this.__tcs34725Gain = gain;
	}
	getRawData() {
		if (!this.__tcs34725Initialised) this.begin();

		var cdatal = this.__read8(TCS34725_CDATAL);
		var cdatah = this.__read8(TCS34725_CDATAH);
		var cdata = (cdatal | (cdatah<<8));

		var rdatal = this.__read8(TCS34725_RDATAL);
		var rdatah = this.__read8(TCS34725_RDATAH);
		var rdata = (rdatal | (rdatah<<8));

		var gdatal = this.__read8(TCS34725_GDATAL);
		var gdatah = this.__read8(TCS34725_GDATAH);
		var gdata = (gdatal | (gdatah<<8));

		var bdatal = this.__read8(TCS34725_BDATAL);
		var bdatah = this.__read8(TCS34725_BDATAH);
		var bdata = (bdatal | (bdatah<<8));

		return({
			'c': cdata, 'r': rdata, 'g': gdata, 'b': bdata
		});
	}
	getRGB() {
		var rgbc = this.getRawData();
		return({
			'r': parseInt((rgbc.r/rgbc.c)*256),
			'g': parseInt((rgbc.g/rgbc.c)*256),
			'b': parseInt((rgbc.b/rgbc.c)*256)
		});
	}
	measure() {
	}
	get value() {
		var rgbc = this.getRawData();
		return({
			'r': parseInt((rgbc.r/rgbc.c)*256),
			'g': parseInt((rgbc.g/rgbc.c)*256),
			'b': parseInt((rgbc.b/rgbc.c)*256)
		});
	}
	setInterrupt(i) {
	}
	clearInterrupt() {
	}
	toJSON() {
		return({
			id: this.id,
			status: this.status,
			value: this.value
		});
	}
}

export default TCS34725;